import React from "react";
import { Button, Modal } from "antd";

const DeleteUserModal = ({ isModalVisible, setIsModalVisible, onConfirm, userId , userName}) => {
  const handleCancelDelete = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <Modal
        title="Delete User"
        open={isModalVisible}
        onOk={onConfirm}
        onCancel={handleCancelDelete}
        centered // This ensures the modal is vertically centered
        footer={[
          <Button
            className="primary-button"
            variant="solid"
            onClick={handleCancelDelete}
          >
            No
          </Button>,
          <Button className="primary-button" onClick={onConfirm}>
            Yes
          </Button>,
        ]}
      >
        <p style={{ marginBottom: "25px" }}>
          Are you sure you want to delete User {userName} ({userId})?
        </p>
      </Modal>
    </>
  );
};

export default DeleteUserModal;
